import { jsx as p } from "react/jsx-runtime";
import { cssX as s } from "../../core/utils/css.js";
import { c as a } from "../../index-C7ezJk5b.js";
const c = ({
  children: r,
  className: o
}) => /* @__PURE__ */ p("div", { className: a(
  s("Wrapper"),
  o
), children: r });
export {
  c as default
};
